export default __webpack_public_path__ + "static/media/thinkcopy-mobile.613699ad.png";